<template>
  <aw-forgotten-password />
</template>

<script setup lang="ts">
  import AwForgottenPassword from '~~/common/components/Page/AwForgottenPassword.vue';

  defineOptions({
    name: 'ForgottenPasswordPage',
  });
</script>
